<template>

  <ContentsProductHighPerformancePageTitle title="POM (Polyacetal)" />

  <!-- PRODUCT DETAIL PAGE -->
  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/commodity-plastics/fer02.jpg"
            :contents="[
              'POM is mostly known of its superior low friction and wear resistance. Therefore, it’s commonly used where good abrasion is needed. Other outstanding properties are high heat, high stiffness, good fatigue and creep, and chemical resistance. Disadvantage of POM is it’s impossible to add flame retardant. POM is available in homopolymer and copolymer'
            ]"
            is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
          
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/commodity-plastics/pom.jpg"
            :contents="[
              'Gear, automotive inside door handle, conveyor, bearing and other moving parts'
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :is-remove-contact-text="true"
          :partners="[
            {
              name: 'Polyplastics',
              image: {
                width: 766,
                height: 178,
                src: '/pages/products/commodity-plastics/poly.jpg',
              },
            },
            {
              name: 'Asahi Kasei',
              image: {
                width: 300,
                height: 41,
                src: '/pages/products/commodity-plastics/ASAHI-KASEI.png',
              },
            },
            {
              name: 'Dupont',
              image: {
                width: 700,
                height: 271,
                src: '/pages/products/commodity-plastics/DuPont_logo-700x271-1.png',
              },
            },
            {
              name: 'Sabic',
              image: {
                width: 272,
                height: 145,
                src: '/pages/products/commodity-plastics/Screen-Shot-2565-05-19-at-15.08.54.png',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title:'pom - NAGASE THAILAND Engineering Plastics',
  meta: [
    {
      rel: 'alternate',
      hreflang: 'en',
      href: `https://group.nagase.com/th/plastics/${process.env.VITE_LANG}/products/commodity-plastics/pom-2`,
    }
  ]
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>